import { useDispatch } from 'react-redux'
import { MemberListWithFallback as List } from 'ui-components'

import { useDeleteWorkspaceMemberMutation } from '~workspace/services/member'
import { openInviteMemberDialog } from '~workspace/states/ui'
import { useIsWorkspaceOwner, useWorkspace } from '~workspace/states/workspace'

const MemberList = () => {
  const dispatch = useDispatch()
  const isWorkspaceOwner = useIsWorkspaceOwner()
  const workspace = useWorkspace()

  const [deleteWorkspaceMember, { isLoading }] =
    useDeleteWorkspaceMemberMutation()

  const handleInviteMemberClick = () => {
    dispatch(openInviteMemberDialog())
  }

  const handleConfirmRemoveMember = async (event, member) => {
    await deleteWorkspaceMember(member.id)
  }

  return (
    <List
      members={workspace?.memberCollection?.items}
      canInviteMember={isWorkspaceOwner}
      canDeleteMember={isWorkspaceOwner}
      isDeletingMember={isLoading}
      onInviteMemberClick={handleInviteMemberClick}
      onDeleteMemberConfirm={handleConfirmRemoveMember}
    />
  )
}

export { MemberList }
export default MemberList
